export const HOME = {
  banner: "top-banner",
  header: "site-header",
  logo: "site-logo",
  adminBtn: "header-admin-btn",
  resultCard: "home-result-card",
  resultDate: "home-result-date",
  r1Label: "home-r1-label",
  r2Label: "home-r2-label",
  r1Value: "home-r1-value",
  r2Value: "home-r2-value",
};

export const GRID = {
  container: "grid-container",
  tileCommon: "tile-common-number",
  tileBlog: "tile-blog",
  tileDream: "tile-dream-number",
  tilePredict: "tile-predict-number",
  tileTarget: "tile-predict-target",
  tilePrev: "tile-previous-result",
  tileCal: "tile-teer-calendar",
  tileCounter: "tile-reputed-counter",
  tileNight: "tile-night-teer-app",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPass: "admin-login-password",
  loginBtn: "admin-login-submit",
  loginError: "admin-login-error",
  logoutBtn: "admin-logout-btn",

  tabDaily: "admin-tab-daily",
  tabCommon: "admin-tab-common",
  tabSettings: "admin-tab-settings",
  tabBlog: "admin-tab-blog",
  tabDream: "admin-tab-dream",
  tabCounter: "admin-tab-counter",

  // Daily
  dailyDate: "admin-daily-date",
  dailyR1: "admin-daily-r1",
  dailyR2: "admin-daily-r2",
  dailySave: "admin-daily-save",

  // Common
  commonDate: "admin-common-date",
  comR1Dir: "admin-com-r1-direct",
  comR1Hou: "admin-com-r1-house",
  comR1End: "admin-com-r1-ending",
  comR2Dir: "admin-com-r2-direct",
  comR2Hou: "admin-com-r2-house",
  comR2End: "admin-com-r2-ending",
  commonSave: "admin-common-save",

  // Settings
  setR1: "admin-set-r1-label",
  setR2: "admin-set-r2-label",
  setTitle: "admin-set-site-title",
  setBanner: "admin-set-banner-text",
  setSave: "admin-set-save",

  // Blog
  blogTitle: "admin-blog-title",
  blogExcerpt: "admin-blog-excerpt",
  blogContent: "admin-blog-content",
  blogSave: "admin-blog-save",

  // Dream
  dreamKeyword: "admin-dream-keyword",
  dreamNumber: "admin-dream-number",
  dreamSave: "admin-dream-save",

  // Counter
  counterName: "admin-counter-name",
  counterLoc: "admin-counter-location",
  counterPhone: "admin-counter-phone",
  counterSave: "admin-counter-save",
};
